import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

/**
 * Bottom tab bar component for performance view navigation
 * @param {Object} props - Component props
 * @param {number} props.tabIndex - Current active tab index
 * @param {Function} props.onTabChange - Tab change handler
 * @returns {JSX.Element} BottomTabBar component
 */
const BottomTabBar = ({ tabIndex, onTabChange }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 40,
        background: "linear-gradient(90deg, #ffffff, #f7f7f7)",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.15)",
        borderTop: "1px solid #ddd",
        px: 2,
        py: 1,
        mt: -1,
        mb: -1,
      }}
    >
      {/* Left logo section */}
      <Box sx={{ flexShrink: 0 }}>
        <a href="https://www.kairos-eu.com/" target="_blank" rel="noopener noreferrer">
          <img
            src="/images/KAIROS_logo.png"
            alt="KAIROS Logo"
            style={{ height: 30 }}
          />
        </a>
      </Box>

      {/* Center tabs section */}
      <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
        <Tabs
          value={tabIndex}
          onChange={onTabChange}
          centered
          sx={{ minWidth: "200px" }}
        >
          <Tab
            label="Maps"
            id="tab-0"
            aria-controls="tabpanel-0"
            sx={{
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1.3rem",
              transition: "all 0.3s ease-in-out",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
          <Tab
            label="Metrics"
            id="tab-1"
            aria-controls="tabpanel-1"
            sx={{
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1.3rem",
              transition: "all 0.3s ease-in-out",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </Tabs>
      </Box>

      {/* Right section (empty for now) */}
      <Box sx={{ flexShrink: 0 }}>
        {/* Reserved for future content */}
      </Box>
    </Box>
  );
};

export default BottomTabBar;
